import { formatDate, calculateAge } from "@/utils/format";
var EM_DASH = "—";

/** Joins non-empty values with a separator, or returns an em dash when none exist. */
function joinOrDash(values, separator) {
  var filtered = (values !== null && values !== void 0 ? values : []).filter(function (value) {
    return Boolean(value && value.trim());
  });
  return filtered.length ? filtered.join(separator) : EM_DASH;
}

/** Builds the label/value rows shown in the patient details list. */
export function buildPatientDetailRows(details) {
  var basic_info = details.basic_info,
    contact = details.contact,
    insurance_coverage = details.insurance_coverage,
    general_practitioner = details.general_practitioner;
  var age = calculateAge(basic_info.dob);
  var dobValue = basic_info.dob ? "".concat(formatDate(basic_info.dob)).concat(age !== null ? " \xB7 ".concat(age, "Y") : "") : EM_DASH;
  var insurance = insurance_coverage ? joinOrDash([insurance_coverage.insurance_provider, insurance_coverage.policy_number], " · ") : EM_DASH;
  return [{
    key: "dob",
    labelKey: "dob",
    value: dobValue
  }, {
    key: "gender",
    labelKey: "gender",
    value: basic_info.gender || EM_DASH
  }, {
    key: "identifier",
    labelKey: "identifier",
    value: basic_info.mrn_number || EM_DASH
  }, {
    key: "languages",
    labelKey: "languages",
    value: joinOrDash(basic_info.languages, ", ")
  }, {
    key: "phone",
    labelKey: "phone",
    value: contact.phone || EM_DASH,
    isLink: true
  }, {
    key: "email",
    labelKey: "email",
    value: contact.email || EM_DASH,
    isLink: true
  }, {
    key: "address",
    labelKey: "address",
    value: contact.address || EM_DASH
  }, {
    key: "insurance",
    labelKey: "insurance",
    value: insurance
  }, {
    key: "practitioner",
    labelKey: "practitioner",
    value: joinOrDash((general_practitioner !== null && general_practitioner !== void 0 ? general_practitioner : []).map(function (practitioner) {
      return practitioner.display;
    }), ", ")
  }];
}